module.exports = __webpack_public_path__ + "static/bozbark-icon-3f19a7e721711365500973ed5e87c8a8.png";